module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patients"
  }, [_c('md-card', [_c('md-card-header', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.$t("admin.patients")))])]), _vm._v(" "), _c('md-card-content', {
    staticClass: "row"
  }, [_c('md-checkbox', {
    model: {
      value: (_vm.showHidden),
      callback: function($$v) {
        _vm.showHidden = $$v
      },
      expression: "showHidden"
    }
  }, [_vm._v("Rejtett felhasználók megjelenítése")])], 1)], 1), _vm._v(" "), _c('md-table-card', [_c('md-table', {
    attrs: {
      "md-sort": "name",
      "md-sort-type": "asc"
    },
    on: {
      "sort": _vm.onSort
    }
  }, [_c('md-table-header', [_c('md-table-row', [_c('md-table-head', [_vm._v(_vm._s(_vm.$t("admin.image")))]), _vm._v(" "), _c('md-table-head', {
    attrs: {
      "md-sort-by": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t("name")))]), _vm._v(" "), _c('md-table-head', {
    attrs: {
      "md-sort-by": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t("email")))]), _vm._v(" "), _c('md-table-head', [_vm._v(_vm._s(_vm.$t("admin.summary")) + " (" + _vm._s(_vm.$t("admin.lastFourWeek")) + ")")]), _vm._v(" "), _c('md-table-head', [_vm._v(_vm._s(_vm.$t("admin.data")))]), _vm._v(" "), _c('md-table-head', [_vm._v("Rejtve")])], 1)], 1), _vm._v(" "), _c('md-table-body', _vm._l((_vm.patientsPage), function(patient, index) {
    return (_vm.showHidden ||  !patient.hidden) ? _c('md-table-row', {
      key: index,
      attrs: {
        "md-item": patient
      }
    }, [_c('md-table-cell', [_c('md-avatar', {
      staticClass: "avatar"
    }, [_c('img', {
      attrs: {
        "src": patient.avatar
      }
    }), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "bottom"
      }
    }, [_c('img', {
      staticClass: "large-avatar",
      attrs: {
        "src": patient.avatar
      }
    })])], 1)], 1), _vm._v(" "), _c('md-table-cell', {
      key: 'name',
      attrs: {
        "md-numeric": false
      }
    }, [_c('span', {
      class: {
        'anonym': !patient.name
      }
    }, [_vm._v(_vm._s(patient.name ? patient.name : "Nincs név megadva"))])]), _vm._v(" "), _c('md-table-cell', {
      key: 'email',
      attrs: {
        "md-numeric": false
      }
    }, [_vm._v(_vm._s(patient.email))]), _vm._v(" "), _c('md-table-cell', [_c('div', [_c('b', [_vm._v(_vm._s(patient.additionalFactors.symptomCount.value))]), _vm._v(" - " + _vm._s(_vm.$t("admin.numberofsymptoms"))), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(patient.additionalFactors.rescueMedicationCount.value))]), _vm._v(" - " + _vm._s(_vm.$t("admin.rescueMedUsage")) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('md-table-cell', [_c('md-button', {
      staticClass: "md-primary",
      on: {
        "click": function($event) {
          _vm.showPatient(patient)
        }
      }
    }, [_vm._v("Adatok")])], 1), _vm._v(" "), _c('md-table-cell', [_c('md-switch', {
      staticClass: "md-primary",
      model: {
        value: (patient.hidden),
        callback: function($$v) {
          _vm.$set(patient, "hidden", $$v)
        },
        expression: "patient.hidden"
      }
    })], 1)], 1) : _vm._e()
  }))], 1), _vm._v(" "), _c('md-table-pagination', {
    attrs: {
      "md-size": _vm.size,
      "md-total": _vm.patients.length,
      "md-page": "1",
      "md-label": "Rows",
      "md-separator": "of",
      "md-page-options": [5, 10, 25, 50]
    },
    on: {
      "pagination": _vm.onPagination
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4863bce4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/PatientList.vue
// module id = 417
// module chunks = 2